import { render, staticRenderFns } from "./errorDialog.vue?vue&type=template&id=572b618e&scoped=true&"
import script from "./errorDialog.vue?vue&type=script&lang=js&"
export * from "./errorDialog.vue?vue&type=script&lang=js&"
import style0 from "./errorDialog.vue?vue&type=style&index=0&id=572b618e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b618e",
  null
  
)

export default component.exports